import * as S from "./styles";

import { Page } from "components/Page";
import { BreadcrumbsProps } from "components/BreadCrumb";
import { useHistory } from "react-router-dom";
import { useMemo } from "react";
import { DefaultFooter } from "components/DefaultFooter";
import { Button } from "components/Button";

import bradescoImage from "assets/images/bradesco.png";
import banestesImage from "assets/images/banestes.png";
import caixaImage from "assets/images/caixa.png";
import { ArrowBack as IconArrowBack } from "@material-ui/icons";
import { ButtonContact } from "components/ButtonContact";

export function LoteTaxas() {
  const history = useHistory();

  const breadcrumbs: BreadcrumbsProps = useMemo(() => {
    return {
      paths: [
        {
          link: "/",
          title: "Página inicial",
        },
        {
          link: "/modalidade",
          title: "Modalidade",
        },
        {
          link: "/financiamento",
          title: "Financiamento",
        },
      ],
      currentPage: "Lote",
    };
  }, []);

  return (
    <Page breadcrumbs={breadcrumbs}>
      <S.Title>Compare as taxas dos principais bancos:</S.Title>

      <S.Content>
        <S.ContainerBanks>
          <S.BankItem>
            <img src={banestesImage} alt="Logo Banestes" />
            <div>
              <strong>Banestes</strong>
              <p>8,99% + TR efetivo, até 80% até 240 meses.</p>
            </div>
          </S.BankItem>

          <S.BankItem>
            <img src={bradescoImage} alt="Logo Bradesco" />
            <div>
              <strong>Bradesco</strong>
              <p>11% + TR efetivo, até 70% até 120 meses.</p>
            </div>
          </S.BankItem>

          <S.BankItem>
            <img src={caixaImage} alt="Logo Caixa Econômica" />
            <div>
              <strong>Caixa Econômica</strong>
              <p>8,25% + TR efetivo, até 70% até 240 meses.</p>
            </div>
          </S.BankItem>
        </S.ContainerBanks>
      </S.Content>
      <S.WrapperButtons>
        <Button
          onClick={() => history.push("/financiamento")}
          startIcon={<IconArrowBack />}
          variant="outlined"
        >
          VOLTAR
        </Button>
        <ButtonContact />
      </S.WrapperButtons>

      <DefaultFooter />
    </Page>
  );
}
